import React from 'react';

import Resources from '../../helpers/resources';
import {appTheme} from '../../styles/app-theme';
import {AppContext} from '../../types';
import {AppProviders, AppProvidersProps} from './app-providers';
import BasicApp from './basic-app';
import {getLocale} from '../../helpers/utils';
import {AppRoutes} from './routes/app-routes';

const config = require('./app-config');
const api: AppContext['api'] = require('../../api').api;

// Allow env in development, eg working with demo
export default class EntryApp extends BasicApp {
    render () {
        // When executing on demo, QA, or production, the host app will inject a property
        // called pppAppConfig into the global window variable.  This will provide the
        // base name of the app.  Most of the time that will be an empty string, but in
        // case it is not, we will extract it and pass it to the router, below.
        const appConfig = window.pppAppConfig;
        const BASE_NAME = appConfig?.BaseName ?? '';

        // || is there to allow for displaying the page even if no translation file is found.
        const { i18n } = window.localisation || { i18n: {} };
        const appContext: Omit<AppContext, 'history'> = {
            api,
            getConfigurationItem: Resources.getConfigurationItem
        };

        const providerContext: AppProvidersProps = {
            language: getLocale(),
            basename: BASE_NAME,
            i18n,
            appContext,
            config,
            theme: appTheme
        };

        return (
            <AppProviders {...providerContext}>
                <AppRoutes/>
            </AppProviders>
        );
    }
}

window.EntryApp = EntryApp;
